import DeliveriesController from 'cio/controllers/deliveries';
import { LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL, LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL } from 'cio/utils/date-picker';

export default class IndexController extends DeliveriesController {
  filterQueryParams = ['action', 'recipient'];
  queryParams = ['actionType', 'action', 'recipient', 'startTs', 'endTs'];
  fetchDrafted = true;
  detailRoute = 'campaigns.campaign.overview.drafts.draft';
  icon = 'draft';
  drafted = true;

  dateRangePresets = [LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL, LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL];
}
